<template>
<nav class="cd-vertical-nav">
			<ul>
				<li>
					<a href="#section-home" class="active smooth"><span class="label">首页</span></a>
				</li>
				<li>
					<a href="#section-about" class="smooth"><span class="label">关于我</span></a>
				</li>
				<li>
					<a href="#section-interest" class="smooth"><span class="label">我的兴趣</span></a>
				</li>
				<li>
					<a href="#section-case" class="smooth"><span class="label">闲暇之余</span></a>
				</li>
				<li>
					<a href="#footer" class="smooth"><span class="label">联系我</span></a>
				</li>
			</ul>
		</nav>
</template>

<style scoped>
@import "../assets/css/vertical.css";
</style>

<script>
export default {
  name: 'VerticalNav'
}
</script>